export default __webpack_public_path__ + "static/main_bg-5d41ed655be5e4cd1c6cd68bb46ee03d.svg";